import React, { useContext, useEffect, useState } from "react"
import { useHistory, withRouter } from "react-router-dom"

import { userContext } from "../../../context/userContext"
import { roleContext } from "../../../context/RoleContext"

//Import for visitor login API handler
import { VisitorLoginApi } from '../../../api/auth/login/LoginApi'

import NotificationManager from "react-notifications/lib/NotificationManager"

//Imports for animations
import styled, { keyframes } from "styled-components"
import { fadeIn } from 'react-animations'

import Lottie from 'react-lottie'
import eyeAnimation from "../../../assets/lotties/lottie-eye"

const fadeInAnimation = keyframes`${fadeIn}`
const FadeInDiv = styled.div`animation:  0.9s ${fadeInAnimation};`

//Initial State
const initialState = {
  errorEmail: "",
  errorPassword: "",
  errorEmailIsOpen: false,
  errorPasswordIsOpen: false,
  passVisible: false,
  emailList: ["@gmail", "@yahoo", "@outlook", "@pkteam"],

  userData: {
    email: "",
    password: "",
  },
  visitor: {
    visitor_id: "",
    email: "",
    name: "",
    password: "",
    status: true,
    photo: "",
    phone: ""
  }
}

const VisitorLogin = (props) => {
  const { visible, setVisible } = useContext(userContext)
  const { role, setRole } = useContext(roleContext)
  const [enteredEmail, setEnteredEmail] = useState(initialState.userData.enteredEmail)
  const [enteredPassword, setEnteredPassword] = useState(initialState.userData.enteredPassword)
  const [userData, setUserData] = useState(initialState.userData)
  const [passVisible, setPassVisible] = useState(initialState.passVisible)
  const [loading, setLoading] = useState(false)

  const [visitor, setVisitor] = useState(initialState.visitor)

  const emailList = useState(initialState.emailList)

  const [errorEmail, setErrorEmail] = useState(initialState.errorEmail)
  const [errorPassword, setErrorPassword] = useState(initialState.errorPassword)
  const [errorEmailIsOpen, setErrorEmailIsOpen] = useState(initialState.errorEmailIsOpen)
  const [errorPasswordIsOpen, setErrorPasswordIsOpen] = useState(initialState.errorPasswordIsOpen)

  // const [firstName, setFirstName] = useState(initialState.visitor.firstName)
  // const [lastName, setLastName] = useState(initialState.visitor.lastName)
  // const [telephone, setTelephone] = useState(initialState.visitor.telephone)
  // const [email, setEmail] = useState(initialState.visitor.email)
  // const [password, setPassword] = useState(initialState.visitor.password)
  // const [status, setStatus] = useState(initialState.visitor.status)

  const [visitorDetail, setVisitorDetail] = useState(initialState.visitor)

  const history = useHistory()

  const eyeDefaultOptions = {
    loop: true,
    autoplay: false,
    animationData: eyeAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice"
    }
  }

  //Runs once on render
  useEffect(() => {
    setVisible(false)

    if (localStorage.getItem("token") && localStorage.getItem('role') === 'visitor')
      history.push("/visitor")
  }, [])

  //Runs whenever visitorDetail is changed
  useEffect(() => {
    localStorage.setItem('visitor_detail', JSON.stringify(visitorDetail))

    localStorage.setItem('user_email', userData.email)
    localStorage.setItem('role', 'visitor')

    if (localStorage.getItem('token')) {
      NotificationManager.success(`Welcome Back ${localStorage.getItem('user_name')}`, "Success", 1000)
      history.push("/visitor")
    }
  }, [visitorDetail])

  //onChange handler for input fields
  const handleChange = (event) => {
    const { name, value } = event.target

    if (name === 'email') {
      emailValidation(event)
      setUserData(prevUserData => ({
        ...prevUserData,
        [name]: value,
      }))
    } else {
      passwordValidation(event)
      setUserData(prevUserData => ({
        ...prevUserData,
        [name]: value,
      }))
    }
  }

  //validate email Field
  const emailValidation = (event) => {
    if (event.target.value.length === 0) {
      setErrorEmail("* Empty Field")
      setErrorEmailIsOpen(true)
      return false
    } else {
      if (!event.target.value.includes(emailList[0][0])) {
        if (!event.target.value.includes(emailList[0][1])) {
          if (!event.target.value.includes(emailList[0][2])) {
            if (!event.target.value.includes(emailList[0][3])) {
              setErrorEmail("* Enter a valid email address")
              setErrorEmailIsOpen(true)
              return false
            }
          }
        }
      }
    }

    setErrorEmail("")
    setErrorEmailIsOpen(false)
    return true
  }

  //Validate password Field
  const passwordValidation = (event) => {
    if (event.target.value.length === 0) {
      setErrorPassword("Empty Field")
      setErrorPasswordIsOpen(true)
      return false
    } else {
      if (event.target.value.length < 6) {
        setErrorPassword("Enter password with atleast 6 characters")
        setErrorPasswordIsOpen(true)
        return false
      }
    }

    setErrorPassword("")
    setErrorPasswordIsOpen(false)
    return true
  }

  //Handler for login button click
  const handleLoginClick = (event) => {
    // var user = {
    //   enteredEmail: enteredEmail,
    //   enteredPassword: enteredPassword,
    // }

    // setUserData(user)

    event.preventDefault()

    setLoading(true)

    let visitorFormData = new FormData()

    visitorFormData.append('email', userData.email)
    visitorFormData.append('password', userData.password)

    //API call handler for logging in Visitor
    VisitorLoginApi(visitorFormData)
      .then(res => {
        console.log(res)

        if (res.status === 401) {
          NotificationManager.error('Email or password is incorrect', "Error", 1000)
        } else if (res.message === 'User is Suspended') {
          NotificationManager.error("You've been suspended, please contact admin for support.", "Error", 1000)
        } else if (res.status === 400) {
          NotificationManager.error("User doesn't exist.", "Error", 1000)
        } else if (res.status === 141) {
          localStorage.setItem("token", "asda")
          localStorage.setItem("role", "visitor")
          setLoading(false)
          history.push("/visitor")
        } else {
          localStorage.setItem('token', `Bearer ${res.access_token}`)
          localStorage.setItem('name', res.name)
          localStorage.setItem('user_id', res.user_id)
          localStorage.setItem('photo', res.photo)
          localStorage.setItem('role', 'visitor')

          setLoading(false)

          history.push("/visitor")

          // setFirstName(res.firstName)
          // setLastName(res.lastName)
          // setPassword(res.password)
          // setEmail(res.email)
          // setTelephone(res.telephone)
          // setStatus(res.status)

          // var visitor_detail = {
          //   _id: res._id,
          //   firstName: res.firstName,
          //   lastName: res.lastName,
          //   email: res.email,
          //   telephone: res.telephone,
          //   password: res.password,
          //   profile_pic: res.profile_pic,
          //   status: res.status
          // }

          // localStorage.setItem('user_name', res.firstName + " " + res.lastName)

          // setVisitorDetail(visitor_detail)
        }
      }).catch(err => {
        setLoading(false)
        NotificationManager.error("Somehting went wrong: " + err, "Error", 1000)
      })
  }

  return (
    <FadeInDiv className="container">
      <div className="row justify-content-center">
        <div className="col-xl-8 col-lg-6 col-md-9">
          <div className="card o-hidden shadow-lg my-5">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-lg-3 d-none d-lg-block">
                </div>
                <div className="col-lg-6">
                  <div className="p-5">
                    <div className="text-center">
                      <h1 className="h4 mb-4" style={{ color: '#59b1a7' }}>Visitor Login</h1>
                    </div>
                    <form className="user" onSubmit={handleLoginClick}>
                      <div className="form-group" style={{ position: 'relative' }}>
                        <input
                          style={{ borderRadius: "50px" }}
                          type="email"
                          maxLength='36'
                          className="form-control form-control-sm"
                          id="exampleInputEmail"
                          aria-describedby="emailHelp"
                          placeholder="example@mail.com"
                          name="email"
                          onChange={handleChange}
                        />
                        {errorEmailIsOpen ?
                          <FadeInDiv
                            className='alert alert-danger'
                            role='alert'
                          >
                            {errorEmail}
                          </FadeInDiv> :
                          <></>
                        }
                      </div>
                      <div className="form-group" style={{ position: 'relative' }}>
                        <input
                          style={{ borderRadius: "50px" }}
                          type={passVisible ? "text" : "password"}
                          className="form-control form-control-sm"
                          id="exampleInputPassword"
                          maxLength='6'
                          placeholder="Enter Password..."
                          name="password"
                          onChange={handleChange}
                        />
                        {errorPasswordIsOpen ?
                          <FadeInDiv
                            className='alert alert-danger'
                            role='alert'
                          >
                            {errorPassword}
                          </FadeInDiv> :
                          <></>
                        }
                      </div>

                      <div className="form-group">
                        <div className="small">
                          <i
                            style={{ color: '#59b1a7', float: "left", paddingTop: "5px" }}
                            onClick={() => setPassVisible(prevState => !prevState)}
                            className={passVisible ? "far fa-eye" : "far fa-eye-slash"}
                          ></i>
                          <label
                            style={{ paddingLeft: "10px" }}
                            onClick={() => setPassVisible(prevState => !prevState)}
                          >
                            {passVisible ? "Hide Password" : "Show Password"}
                          </label>
                        </div>
                      </div>
                      <button
                        className="btn btn-block text-center"
                        disabled={loading}
                        style={{ backgroundColor: '#59b1a7', color: 'white', borderRadius: "50px" }}
                        type="submit"
                      >
                        {loading ? "Logging in..." : "Login"}
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </FadeInDiv>
  )
}

export default withRouter(VisitorLogin)
